import React, { useEffect } from 'react'
import useAuthStore from '../../store/useAuthStore';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = () => {
  const { username, role, email, checkAuth } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-900 text-white">
      <h1 className="text-3xl font-bold text-blue-400 mb-4">Welcome, Admin!</h1>
      <div className="bg-gray-800 rounded-xl p-6 shadow-lg w-[90%] max-w-xl">
        <p className="text-lg mb-2"><strong>Username:</strong> {username}</p>
        <p className="text-lg mb-2"><strong>Email:</strong> {email}</p>
        <p className="text-lg"><strong>Role:</strong> {role}</p>
      </div>

      <button
        className="mt-6 px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded text-white font-semibold"
        onClick={() => navigate('/admin/upload-resume')}
      >
        Upload Resume
      </button>
    </div>
  );
};

export default AdminDashboard;
